import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import SearchBar from "@/components/base/SearchBar";

const NAV_ITEMS = [
  { to: "/", label: "首页" },
  { to: "/category", label: "电视剧" },
  { to: "/about", label: "关于" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const solid = scrolled || !isHome || menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid
          ? "bg-primary-950 border-b border-background-50/10"
          : "bg-gradient-to-b from-primary-950/85 to-transparent"
      }`}
    >
      <div className="flex h-16 w-full items-center justify-between gap-4 px-4 md:h-[72px] md:px-8">
        <Link to="/" className="flex shrink-0 items-center gap-2.5" aria-label="嫂子的职业在线观看 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500">
            <i className="ri-film-line text-lg text-primary-950" aria-hidden="true" />
          </span>
          <span className="leading-tight">
            <span className="block font-heading text-base font-bold tracking-wide text-background-50 md:text-lg">
              嫂子的职业
            </span>
            <span className="block text-[10px] tracking-[0.28em] text-background-300">在线观看</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `relative rounded-md px-4 py-2 text-sm transition-colors ${
                  isActive
                    ? "text-background-50 font-medium"
                    : "text-background-200 hover:text-background-50"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {item.label}
                  {isActive && (
                    <span className="absolute inset-x-4 -bottom-0.5 h-0.5 rounded-full bg-accent-500" />
                  )}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="hidden w-[300px] shrink-0 lg:block">
          <SearchBar variant="header" placeholder="搜索剧名 / 演员" />
        </div>

        <div className="flex items-center gap-2 lg:hidden">
          <Link
            to="/search"
            aria-label="搜索"
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-50/20 text-background-100"
          >
            <i className="ri-search-line" aria-hidden="true" />
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-expanded={menuOpen}
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-50/20 text-background-100 md:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-50/10 bg-primary-950 px-4 pb-6 pt-4 md:hidden">
          <SearchBar variant="header" placeholder="搜索剧名 / 演员 / 题材" className="mb-4" />
          <nav className="flex flex-col" aria-label="移动端主导航">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `flex items-center justify-between border-b border-background-50/10 py-3 text-sm ${
                    isActive ? "text-accent-400" : "text-background-100"
                  }`
                }
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-background-400" aria-hidden="true" />
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}